import requests from "./httpServices";
import { showErrorAlert } from "./AlertService";

const AuthServices = {
    register: async (userdetials) => {
        try {
            const response = await requests.post('/auth/register', userdetials);
            return response;
        } catch (error) {
            showErrorAlert(error);
            throw error; // Re-throw so calling code can handle it
        }
    },

    schoolregister: async (userdetials) => {
        try {
            const response = await requests.post('/auth/schoolregister', userdetials);
            return response;
        } catch (error) {
            console.log(error, "errorr");
            showErrorAlert(error);
            throw error; // Re-throw so calling code can handle it
        }
    },

    teacherregister: async (userdetials) => {
        try {
            const response = await requests.post('/auth/teacherregister', userdetials);
            return response;
        } catch (error) {
            showErrorAlert(error);
            throw error; // Re-throw so calling code can handle it
        }
    },

    login: async (userdetials) => {
        try {
            const response = await requests.post('/auth/login', userdetials);

            // Validate response structure based on role
            // CRITICAL FIX: If mustChangePassword is true, we don't expect a token or user data yet.
            if (response.mustChangePassword === true) {
                console.log("Login response: Password change required, bypassing token validation.");
                return response;
            }

            if (!response.token) {
                throw new Error("No token received from server");
            }

            // Validate required fields
            if (!response.role && response.role !== 0) {
                throw new Error("No role information in response");
            }

            if (!response.user || !response.user._id || !response.user.id) {
                // Support both _id (Mongo) and id (Postgres)
                if (!response.user?.id && !response.user?._id) {
                    throw new Error("Invalid user data in response");
                }
            }

            // Log response structure for debugging
            console.log("Login response validated:", {
                hasToken: !!response.token,
                role: response.role,
                hasUser: !!response.user,
                hasAmount: 'amount' in response,
                hasQuizCompleted: 'is_quiz_completed' in response,
                hasPayment: 'is_payment' in response,
                hasMustChangePassword: 'mustChangePassword' in response
            });

            return response;
        } catch (error) {
            console.error("Login API error:", {
                message: error?.message,
                response: error?.response?.data,
                status: error?.response?.status,
                statusText: error?.response?.statusText,
                code: error?.code,
                config: {
                    url: error?.config?.url,
                    baseURL: error?.config?.baseURL,
                    method: error?.config?.method,
                }
            });

            // Extract error message from response
            let errorMessage = "Login failed. Please try again.";

            if (error?.response?.data?.error) {
                errorMessage = error.response.data.error;

                // Enhance school payment error message
                if (errorMessage.includes("School Payment Error")) {
                    errorMessage = "Your school's payment has expired. Please contact your school administrator to renew the subscription.";
                }
            } else if (error?.response?.status === 404) {
                errorMessage = "User not found. Please check your email and password.";
            } else if (error?.response?.status === 401) {
                errorMessage = "Invalid credentials. Please check your email and password.";
            } else if (error?.code === 'ECONNREFUSED' || error?.message?.includes('Network Error')) {
                errorMessage = "Cannot connect to server. Please check your internet connection.";
            }

            // Show error alert with the extracted message
            const { showErrorAlert } = require('./AlertService');
            showErrorAlert({ response: { data: { error: errorMessage } } });

            throw error;
        }
    },



    viewCertificateByUserId: async (param) => {
        try {
            const response = await requests.get(`/auth/certificate/${param.userid}?type=${param.type}`);
            return response;
        } catch (error) {
            showErrorAlert(error);
        }
    },
    forgotPassword: async (userdetials) => {
        try {
            const response = await requests.post('/auth/forgotPassword', userdetials);
            return response;
        } catch (error) {
            showErrorAlert(error);
        }
    },
    resetPassword: async (token, param) => {
        try {
            const response = await requests.post(`/auth/reset-password/${token}`, param);
            return response;
        } catch (error) {
            showErrorAlert(error);
        }
    },
    checkPromoCode: async (promoData) => {
        try {
            const response = await requests.postWithoutIP('/auth/check-promo-code', promoData);
            return response;
        } catch (error) {
            console.error("Promo code check error:", error);
            throw error; // Re-throw the error so the component can handle it
        }
    },
};

export default AuthServices;